import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import {getuserCallBack} from '../../../../services/met/Service';


const CallHistory = ({showcallHistoryDetailsModal, setShowcallHistoryDetailsModal, memberName, userId}) => {

    const [memberCallList, setMemberCallList] = useState([]); 


    useEffect(() => { 
        fetchCallHistoryRecords(); 
    }, []); 

    async function fetchCallHistoryRecords(){
        try{ 
            const response = await getuserCallBack(userId, 'callhistory'); 
            const responseData = response.data?.callData || []; 
            

            if(responseData.length > 0){ 
                setMemberCallList(response.data.callData); 
            }
        }catch(e){ 

        }
    }




  return (
    <div className="tw-fixed tw-inset-0 tw-bg-black/45 tw-z-[9999]">
    <Modal style={{zIndex:"9999"}} id="callHistoryDetails" show={showcallHistoryDetailsModal} onHide={() => setShowcallHistoryDetailsModal(false)} centered size="xl" backdrop="static" keyboard={false} fullscreen={false}>
    <Modal.Header closeButton>
      <h1 className='modal-title me-4'>{memberName}</h1>
    </Modal.Header>
    <Modal.Body>
      <div className='row'>
        {
          memberCallList && memberCallList.length > 0 ?
          <>
            <div className="col-12">
              <h4>Call History</h4>
              <div className="table-responsive" style={{ height: "420px", overflowY: "scroll" }}>
                <table className="table mb-0">
                  <thead>
                    <tr>
                      <th scope="col">Date</th>
                      <th scope="col">Agent Name</th>
                      <th scope="col">Enrollment Status</th>
                      <th scope="col">Call Duration</th>
                      <th scope="col">Call Status</th>
                      <th scope="col">Data Rating </th>
                      <th scope="col">Reason</th>
                    </tr>
                  </thead>
                  <tbody>
                    {memberCallList?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.placedCallDate}</td>
                        <td>{item.agentName}</td>
                        <td>{item.enrollStatus}</td>
                        <td>{item.callDuration}</td>
                        <td>{item.callStatus}</td>
                        <td>{item.dataRating || "-"}</td>
                        <td>{item.reason || "-"}</td>
                      </tr>
                    ))
                    }
                  </tbody>
                </table>
              </div>
            </div>
            </>: 
            <h2>No call history available for this member</h2>
        }
      </div>
    </Modal.Body>
  </Modal>
  </div>
  )
}

export default CallHistory
